import { createContext } from 'react';

export default createContext({ screenshot: false });
